import React from 'react'

const campanhasAdminRoutes = [

    {
        path: '/campanhas/visualizar',
        exact: true,
        component: React.lazy(() => import('./visualizar/lista/Table')),
    },

    {
        path: '/campanhas/detalhes',
        exact: true,
        component: React.lazy(() => import('./visualizar/form/Form')),
    },

]

export default campanhasAdminRoutes
